/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type AssignConfigurationMutationVariables = Types.Exact<{
  input: Types.DisplayBulkAssignConfigurationsInput;
}>;


export type AssignConfigurationMutation = { __typename: 'Mutation', assignConfiguration: string };

export type CustomerConifgurationsListQueryVariables = Types.Exact<{
  customerHandle: Types.Scalars['String'];
  pageNumber: Types.Scalars['Int'];
  filter?: Types.InputMaybe<Types.ConfigurationFilters>;
}>;


export type CustomerConifgurationsListQuery = { __typename: 'Query', customer?: { __typename: 'Customer', id: string, configurations: Array<{ __typename: 'ConfigurationModel', id: string, name: string, state: Types.ConfigurationStatus, platform: string }> } | null };


export const AssignConfigurationDocument = gql`
    mutation assignConfiguration($input: DisplayBulkAssignConfigurationsInput!) {
  assignConfiguration(input: $input)
}
    `;
export type AssignConfigurationMutationFn = ApolloReactCommon.MutationFunction<AssignConfigurationMutation, AssignConfigurationMutationVariables>;

/**
 * __useAssignConfigurationMutation__
 *
 * To run a mutation, you first call `useAssignConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignConfigurationMutation, { data, loading, error }] = useAssignConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignConfigurationMutation, AssignConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignConfigurationMutation, AssignConfigurationMutationVariables>(AssignConfigurationDocument, options);
      }
export type AssignConfigurationMutationHookResult = ReturnType<typeof useAssignConfigurationMutation>;
export type AssignConfigurationMutationResult = ApolloReactCommon.MutationResult<AssignConfigurationMutation>;
export type AssignConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignConfigurationMutation, AssignConfigurationMutationVariables>;
export const CustomerConifgurationsListDocument = gql`
    query CustomerConifgurationsList($customerHandle: String!, $pageNumber: Int!, $filter: ConfigurationFilters) {
  customer: customerByHandle(handle: $customerHandle) {
    id
    configurations(pageNumber: $pageNumber, filter: $filter) {
      id
      name
      state
      platform
    }
  }
}
    `;

/**
 * __useCustomerConifgurationsListQuery__
 *
 * To run a query within a React component, call `useCustomerConifgurationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerConifgurationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerConifgurationsListQuery({
 *   variables: {
 *      customerHandle: // value for 'customerHandle'
 *      pageNumber: // value for 'pageNumber'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerConifgurationsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomerConifgurationsListQuery, CustomerConifgurationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerConifgurationsListQuery, CustomerConifgurationsListQueryVariables>(CustomerConifgurationsListDocument, options);
      }
export function useCustomerConifgurationsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerConifgurationsListQuery, CustomerConifgurationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerConifgurationsListQuery, CustomerConifgurationsListQueryVariables>(CustomerConifgurationsListDocument, options);
        }
export type CustomerConifgurationsListQueryHookResult = ReturnType<typeof useCustomerConifgurationsListQuery>;
export type CustomerConifgurationsListLazyQueryHookResult = ReturnType<typeof useCustomerConifgurationsListLazyQuery>;
export type CustomerConifgurationsListQueryResult = ApolloReactCommon.QueryResult<CustomerConifgurationsListQuery, CustomerConifgurationsListQueryVariables>;